import { useState, useEffect } from "react";
import { api, apiError } from "../api";
import { Layout } from "../components/Layout";

export default function Portal() {
  const [token, setToken] = useState(localStorage.getItem("ozalp_portal") || "");
  const [me, setMe] = useState(null);
  const [asama, setAsama] = useState("giris"); // giris | kod
  const [sozlesme, setSozlesme] = useState("");
  const [telefon, setTelefon] = useState("");
  const [kod, setKod] = useState("");
  const [mockKod, setMockKod] = useState("");
  const [hata, setHata] = useState("");

  useEffect(() => {
    if (!token) return;
    api.get("/portal/me").then((r) => setMe(r.data)).catch(() => { localStorage.removeItem("ozalp_portal"); setToken(""); });
  }, [token]);

  const kodIste = async (e) => {
    e.preventDefault(); setHata("");
    try {
      const r = await api.post("/portal/request-otp", { sozlesme_no: sozlesme, telefon });
      setMockKod(r.data.mock_code); setAsama("kod");
    } catch (err) { setHata(apiError(err)); }
  };
  const dogrula = async (e) => {
    e.preventDefault(); setHata("");
    try {
      const r = await api.post("/portal/verify-otp", { sozlesme_no: sozlesme, telefon, code: kod });
      localStorage.setItem("ozalp_portal", r.data.token); setToken(r.data.token);
    } catch (err) { setHata(apiError(err)); }
  };
  const cikis = () => { localStorage.removeItem("ozalp_portal"); setToken(""); setMe(null); setAsama("giris"); };

  if (token && me) {
    const tl = ((me.odenen || 0) / (me.toplam || 1)) * 100;
    return (
      <Layout>
        <section className="sayfa-basi" data-testid="portal-panel">
          <div className="a-satir" style={{ justifyContent: "space-between" }}>
            <div><div className="veri bel">Daire Sahibi Portalı</div><h1 className="h-orta" style={{ marginTop: 10 }}>Merhaba, {me.ad}</h1></div>
            <button className="a-btn hayalet kucuk" onClick={cikis} data-testid="portal-cikis">Çıkış</button>
          </div>
          <div className="rakamlar" style={{ marginTop: 30 }}>
            <div><b>{me.daire_no}</b><span className="veri">{me.proje_ad}</span></div>
            <div><b>{(me.odenen || 0).toLocaleString("tr-TR")} ₺</b><span className="veri">Ödenen (%{tl.toFixed(0)})</span></div>
            <div><b>{(me.kalan || 0).toLocaleString("tr-TR")} ₺</b><span className="veri">Kalan</span></div>
            <div><b>{me.sonraki_taksit?.tarih}</b><span className="veri">Sonraki taksit · {(me.sonraki_taksit?.tutar || 0).toLocaleString("tr-TR")} ₺</span></div>
          </div>

          <div className="bolum-basi" style={{ marginTop: 50 }}><h2 className="h-orta">Ödeme takibi</h2></div>
          <table className="daire-tablo">
            <thead><tr><th>Tarih</th><th>Tutar</th><th>Durum</th></tr></thead>
            <tbody>
              {(me.taksitler || []).map((t, i) => (
                <tr key={i}><td className="sayi">{t.tarih}</td><td className="sayi">{t.tutar.toLocaleString("tr-TR")} ₺</td><td>{t.durum === "odendi" ? "Ödendi" : "Bekliyor"}</td></tr>
              ))}
            </tbody>
          </table>

          <div className="bolum-basi" style={{ marginTop: 50 }}><h2 className="h-orta">Belgelerim</h2></div>
          <div className="olanaklar">{(me.belgeler || []).map((b, i) => (<div key={i}><span>{b.tarih}</span>{b.ad}</div>))}</div>

          <div className="bolum-basi" style={{ marginTop: 50 }}><h2 className="h-orta">Duyurular</h2></div>
          <div className="haber-liste">{(me.duyurular || []).map((d, i) => (<a key={i} href="#" onClick={(e) => e.preventDefault()}><h3 style={{ fontSize: 18 }}>{d.baslik}</h3><span className="veri">{d.tarih}</span></a>))}</div>
        </section>
      </Layout>
    );
  }

  return (
    <Layout>
      <section className="sayfa-basi">
        <div style={{ maxWidth: 440 }}>
          <div className="veri">Daire Sahibi Girişi</div>
          <h1 className="h-orta" style={{ margin: "14px 0 24px" }}>Portala giriş</h1>
          {asama === "giris" ? (
            <form className="form" onSubmit={kodIste} data-testid="portal-giris-form">
              <div><label>Sözleşme No</label><input required value={sozlesme} onChange={(e) => setSozlesme(e.target.value)} placeholder="OZ-2025-001" data-testid="portal-sozlesme" /></div>
              <div><label>Telefon</label><input required value={telefon} onChange={(e) => setTelefon(e.target.value)} placeholder="+90 555 123 4567" data-testid="portal-telefon" /></div>
              {hata && <div className="form-hata" data-testid="portal-hata">{hata}</div>}
              <button className="dugme" data-testid="portal-kod-iste">SMS kodu gönder</button>
            </form>
          ) : (
            <form className="form" onSubmit={dogrula} data-testid="portal-kod-form">
              <div style={{ border: "1px solid var(--bal)", padding: 14, borderRadius: 2 }} className="veri" data-testid="portal-mock-kod">
                SMS mocklanmıştır. Kodunuz: <b style={{ color: "var(--bal)" }}>{mockKod}</b>
              </div>
              <div><label>Doğrulama Kodu</label><input required value={kod} onChange={(e) => setKod(e.target.value)} data-testid="portal-kod" /></div>
              {hata && <div className="form-hata">{hata}</div>}
              <button className="dugme" data-testid="portal-dogrula">Giriş yap</button>
            </form>
          )}
        </div>
      </section>
    </Layout>
  );
}
